/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React, { useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import Notifications from "./Notifications";
import { Typography } from "@material-ui/core";
import { useGlobalData } from "../../../provider/GlobalDataProvider";

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

function QuickPanel({ history }) {
  const { reload } = useGlobalData();

  useEffect(() => {}, [reload]);

  return (
    <div id="kt_quick_panel" className="kt-quick-panel">
      <a
        href="#"
        className="kt-quick-panel__close"
        id="kt_quick_panel_close_btn"
      >
        <i className="flaticon2-delete" />
      </a>
      <div className="mt-5">
        <Typography
          variant="h6"
          align="center"
          className="mx-1 my-1 text-muted"
        >
          <span>
            <span className="mr-2">
              <i className="fas fa-bell"></i>
            </span>
            <span>Notifications</span>
          </span>
        </Typography>
      </div>
      <div className="mt-4">
        <PerfectScrollbar
          options={perfectScrollbarOptions}
          style={{
            maxHeight: "calc(100vh - 100px)",
            position: "relative",
          }}
        >
          <div className="kt-notification-v2">
            <Notifications history={history} />
          </div>
        </PerfectScrollbar>
      </div>
    </div>
  );
}

export default QuickPanel;
